import { useState } from 'react';
import { Box, Button, FormControl, TextField } from '@mui/material';
import ModalConfirm from '../ModalConfirm';
import localize from '../../common/localize';
import { Delete } from '@mui/icons-material';
import { MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION } from '../../common/utils';

export default function DeleteConfirmationMessage({
  entityType,
  entityName,
  onClickForCancel,
  onClickForConfirm,
  message,
  title,
  setDeleteReason,
  deleteReason,
  fieldTitle,
  additionalMessage,
}) {
  const maximumCharactersForDescription = MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION;
  const [descriptionCount, setDescriptionCount] = useState(0);
  const handleChange = (e) => {
    if (e.target.value) {
      setDescriptionCount(e.target.value.toString().length);
    }

    setDeleteReason(e.target.value);
  };
  const getTitle = () => {
    if (entityType) {
     return <Box className='w-full flex gap-1'>
        <Delete style={{color: 'crimson', width: '25px', height: '25px'}}/>
        {`${title ?? localize.delete} (${entityType})`}
      </Box>

      // return `${title ?? localize.delete} (${entityType})`;
    }

    return <Box className='w-full flex gap-1'>
        <Delete style={{color: 'crimson', width: '25px', height: '25px'}}/>
        {`${title ?? localize.delete}`}
      </Box>

    // return `${title ?? localize.delete}`;
  };

  return (
    <ModalConfirm
      title={getTitle()}
      additionalMessage={additionalMessage}
      message={
        <p className="flex flex-col">
          {message ?? localize.generic_delete_message}
          <br />
          <b>{entityName}</b>
        </p>
      }
      input={
        setDeleteReason && (
          <FormControl required fullWidth>
            <TextField
              InputLabelProps={{ style: { fontSize: '1em' } }}
              inputProps={{
                style: {
                  fontSize: '0.8em',
                },
                maxLength: maximumCharactersForDescription,
              }}
              size="small"
              fullWidth
              multiline
              rows={3}
              id="outlined-basic"
              name="Observation"
              label={fieldTitle ?? localize.observations}
              variant="outlined"
              value={deleteReason}
              onChange={handleChange}
              helperText={`${descriptionCount}/${maximumCharactersForDescription}`}
            />
          </FormControl>
        )
      }
      buttons={
        <>
          <Button
            sx={{ fontSize: '0.8em' }}
            size="small"
            color="error"
            variant="text"
            onClick={onClickForCancel}
            className="app_general_button_data btn-error btn-outline"
          >
            {localize.cancel}
          </Button>
          <Button
            sx={{ fontSize: '0.8em', backgroundColor: '#10366E' }}
            size="small"
            variant="contained"
            onClick={onClickForConfirm}
            className="btn-success app_general_button_data"
          >
            {localize.confirm}
          </Button>
        </>
      }
    />
  );
}
